import type { FieldDescriptor } from './signingTypes';
import { PDF_VIEWER } from './pdfViewerTokens';

interface NextFieldBannerProps {
  nextField: FieldDescriptor | null;
  onNavigate: () => void;
}

export default function NextFieldBanner({ nextField, onNavigate }: NextFieldBannerProps) {
  if (!nextField) return null;

  return (
    <div
      onClick={onNavigate}
      style={{
        position: 'absolute', bottom: 16, left: '50%', transform: 'translateX(-50%)',
        zIndex: 20, cursor: 'pointer',
        display: 'flex', alignItems: 'center', gap: 8,
        padding: '8px 16px', borderRadius: 20,
        backgroundColor: PDF_VIEWER.fieldUnsigned, color: '#fff',
        fontSize: 13, fontWeight: 600,
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        transition: 'opacity 0.2s',
      }}
    >
      <span>Next: {nextField.label}</span>
      <span style={{ opacity: 0.7, fontSize: 11 }}>Page {nextField.page}</span>
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  );
}
